module.exports = __webpack_public_path__ + "static/media/fullscreen.a70cea5c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fullscreen.svg
// module id = 1579
// module chunks = 1